import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound.tsx";
import ExploreProperties from "./components/ExploreProps/ExploreProperties.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import PropertyDetails from "./components/ExploreProps/PropertyDetails.jsx";
import ScrollToTop from "./ScrollToTop.jsx";
import ContactusComponent from "./components/ContactUsPage/ContactusComponent.jsx";
import SellMyProperty from "./global/SellMyProperty.jsx";
import InvestmentOptions from "./components/InvestmentOptions/InvestmentOptions.jsx";
import Auth from "./Auth/Auth.jsx";
import axios from "axios";
import { useEffect } from "react";
import SocialRedirectPage from "./components/SocialMediaPage.jsx";


const API_URL = window.location.href.includes("localhost")
  ? process.env.REACT_APP_API_URL_LOCAL
  : process.env.REACT_APP_API_URL_PROD;

function trackVisitor() {
  const systemName = "skyline-properties";
  const VISITOR_KEY = "visitor_hash";
  const LAST_VISIT_KEY = "last_visited_at";

  // Generate a hash if not exists
  let visitorHash = localStorage.getItem(VISITOR_KEY);
  if (!visitorHash) {
    visitorHash = crypto.randomUUID(); // Modern UUID for uniqueness
    localStorage.setItem(VISITOR_KEY, visitorHash);
  }

  const now = new Date();
  const lastVisited = localStorage.getItem(LAST_VISIT_KEY);

  // Detect device type
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let deviceType = "desktop";

  if (/android/i.test(userAgent)) {
    deviceType = "android";
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    deviceType = "ios";
  }

  // Format date in ISO (preferred for backend)
  const dateISO = now.toISOString();

  // If no last visit or >1 hour difference, trigger API
  if (!lastVisited || now - new Date(lastVisited) > 60 * 60 * 1000) {
    axios
      .put(`${API_URL}api/analytics/visitor-count`, {
        systemName,
        visitorHash,
        deviceType, // Added device info
        date: dateISO,
      })
      .then(() => {
        localStorage.setItem(LAST_VISIT_KEY, dateISO);
      })
      .catch((err) => console.error("Visitor tracking failed:", err));
  }
}

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    trackVisitor();
  }, []);

  return (
 <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/explore-properties" element={<ExploreProperties />} />
          <Route path="/sell-my-property" element={<SellMyProperty />} />
          <Route path="/investment-options" element={<InvestmentOptions />} />


          <Route path="/properties/:slug" element={<PropertyDetails />} />
          <Route path="/contact-us" element={<ContactusComponent />} />

          <Route path="/social-media" element={<SocialRedirectPage />} />

         {/* /  AUTH  */}
          <Route path="/auth" element={<Auth />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
  )
};

export default App;
